import { Page } from "./page";
import { Tour } from "./tour";

export class Highlight extends Page
{
    public images : string[];
    
    public tours : Tour[];
}